import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './gallery.css';
import { Link } from "react-router-dom";

class Gallery extends Component {
    state = {
        galleryVideoUrl: "",
        galleryVideoUpdate: false,
    }

    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    updateGalleryVideo() {
        let width = window.innerWidth;
        let path = window.location.pathname
        path = path.slice(1, 3);

        if (width > 930) {
            if (path === 'en') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_1440.mp4" });
            } else if (path === 'sc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_1440_sc.mp4" });
            } else if (path === 'tc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_1440_tc.mp4" });
            }
        } else if (width > 480) {
            if (path === 'en') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_930.mp4" });
            } else if (path === 'sc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_930_sc.mp4" });
            } else if (path === 'tc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_930_tc.mp4" });
            }
        } else {
            if (path === 'en') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_480.mp4" });
            } else if (path === 'sc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_480_sc.mp4" });
            } else if (path === 'tc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryVideo_480_tc.mp4" });
            }
        }
        document.getElementById('galleryVideo').loop = false;
        document.getElementById('galleryVideo').controls = true;
        document.getElementById('galleryVideo').muted = false;
        document.getElementById('galleryVideo').autoPlay = true;
        this.setState({ galleryVideoUpdate: true });

    }
    updatePopUp = (n) => {
        let PopUpSrc;
        switch (n) {
            case "1": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Conference/enlarge_20250808_0174.jpg"; break;
            case "2": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Conference/enlarge_20250808_0095.jpg"; break;
            case "3": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Conference/enlarge_20250808_0152.jpg"; break;
            case "4": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Conference/enlarge_20250808_0183.jpg"; break;
            case "5": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/AI Model Competition Judging/enlarge_JudgingDayforSubtheme1.jpg"; break;
            case "6": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/AI Model Competition Judging/enlarge_250807-0002.jpg"; break;
            case "7": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/AI Model Competition Judging/enlarge_250807-0085-2.jpg"; break;
            case "8": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/AI Model Competition Judging/enlarge_250807-0176.jpg"; break;
            case "9": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/BAICE Juding/enlarge_R62_5497.jpg"; break;
            case "10": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/BAICE Juding/enlarge_JudgingDay02.jpg"; break;
            case "11": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/BAICE Juding/enlarge_R62_5395.jpg"; break;
            case "12": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/BAICE Juding/enlarge_R62_5992.jpg"; break;
            case "13": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Awards Ceremony/enlarge_20250808_1048.jpg"; break;
            case "14": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Awards Ceremony/enlarge_20250808_0650.jpg"; break;
            case "15": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Awards Ceremony/enlarge_20250808_0805.jpg"; break;
            case "16": PopUpSrc = "/image/gallery/gallery_highlight_enlarge/Awards Ceremony/enlarge_20250808_1286.jpg"; break;
            default: PopUpSrc = ""; break;
        }
        let modalImg = document.getElementById('gallery-image-popup');
        modalImg.setAttribute('src', PopUpSrc);
        if (n === "1") {
            modalImg.closest(".modal-dialog").classList.remove("modal-dialog-xl");
            modalImg.closest(".modal-dialog").classList.add("modal-dialog-sp");
        } else {
            modalImg.closest(".modal-dialog").classList.remove("modal-dialog-sp");
            modalImg.closest(".modal-dialog").classList.add("modal-dialog-xl");
        }
    }
    componentDidMount() {

        document.getElementById('galleryVideo').loop = true;
        document.getElementById('galleryVideo').muted = true;
        document.getElementById('galleryVideo').autoPlay = true;
        document.getElementById('galleryVideo').pause();

        let myModal = document.getElementById('myModal3');
        let video = document.getElementById('video');

        myModal.addEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });

        let currentWidth = window.innerWidth;

        let path = window.location.pathname
        path = path.slice(1, 3);
        if (currentWidth > 480) {
            if (path === 'en') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_1440.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'sc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_1440_sc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'tc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_1440_tc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            }
        } else {
            if (path === 'en') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_480.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'sc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_480_sc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'tc') {
                this.setState({ galleryVideoUrl: "https://globalaichallenge.com/static/media/galleryteaser_480_tc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            }
        }
    }
    render() {
        const { t } = this.props;
        const { galleryVideoUpdate, galleryVideoUrl } = this.state;
        let path = window.location.pathname
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('gallery-meta-title')}</title>
                    <meta name="title" content={t('gallery-meta-title')} />
                    <meta name="description" content={t('gallery-meta-description')} />
                    <meta name="keywords" content={t('gallery-meta-keywords')} />
                </MetaTags>
                <div id="div-gallery">
                    <div className="gallery-banner">
                        <div className="container-fluid d-flex justify-content-center align-items-center">
                            <h1>{t('gallery-banner-text')}</h1>
                        </div>
                    </div>
                    <div className="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item carousel-item-2 d-flex align-items-end active" onClick={() => this.updateGalleryVideo()}>
                                <div className={galleryVideoUpdate ? "d-none" : "d-flex justify-content-center div-btn_watch mb-4"}>
                                    <button className="btn btn-highlight01 w-100 py-1"><strong>{t('Watch the Full Video')}</strong></button>
                                </div>
                                <video autoPlay loop muted playsInline id="galleryVideo" src={galleryVideoUrl} type="video/mp4" className={galleryVideoUpdate ? "carousel-video updated" : "carousel-video"}>
                                </video>
                            </div>
                        </div>
                    </div>


                    {/* <div className="gallery-video"><video autoPlay loop muted playsInline controls id="galleryVideo" src="https://storage.googleapis.com/emsd_video/211012%20-%20HKSTP%20Highlight%20V4.mp4" type="video/mp4" ></video></div> */}
                    <div className="gallery-section">
                        <h2 className="text-center pt-5 pb-3 gallery-headline-text">{t('gallery-headline-1')}</h2>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-award-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('13')}></div>
                                <div className="d-flex">
                                    <div className="gallery-award-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('14')}></div>
                                    <div className="gallery-award-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('15')}></div>
                                    <div className="gallery-award-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('16')}></div>
                                </div>
                                <div className="d-flex justify-content-center py-4">
                                    <Link className="no_border" onClick={() => this.goToTop()} to={match + "/gallery-awards"}><button className="btn btn-highlight01 px-4 py-1"><strong>{t('btn-see-more')}</strong></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="gallery-section">
                        <h2 className="text-center pt-5 pb-3 gallery-headline-text">{t('gallery-headline-2')}</h2>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-conf-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('1')}></div>
                                <div className="d-flex">
                                    <div className="gallery-conf-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('2')}></div>
                                    <div className="gallery-conf-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('3')}></div>
                                    <div className="gallery-conf-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('4')}></div>
                                </div>
                                <div className="d-flex justify-content-center py-4">
                                    <Link className="no_border" onClick={() => this.goToTop()} to={match + "/gallery-conference"}><button className="btn btn-highlight01 px-4 py-1"><strong>{t('btn-see-more')}</strong></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-section">
                        <h2 className="text-center pt-5 pb-3 gallery-headline-text">{t('gallery-headline-3')}</h2>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-workshop-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('5')}></div>
                                <div className="d-flex">
                                    <div className="gallery-workshop-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('6')}></div>
                                    <div className="gallery-workshop-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('7')}></div>
                                    <div className="gallery-workshop-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('8')}></div>
                                </div>
                                <div className="d-flex justify-content-center py-4">
                                    <Link className="no_border" onClick={() => this.goToTop()} to={match + "/gallery-competition"}><button className="btn btn-highlight01 px-4 py-1"><strong>{t('btn-see-more')}</strong></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gallery-section">
                        <h2 className="text-center pt-5 pb-3 gallery-headline-text">{t('gallery-headline-4')}</h2>
                        <div className="container-fluid d-flex justify-content-center">
                            <div>
                                <div className="gallery-meeting-1" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('9')}></div>
                                <div className="d-flex">
                                    <div className="gallery-meeting-2" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('10')}></div>
                                    <div className="gallery-meeting-3" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('11')}></div>
                                    <div className="gallery-meeting-4" data-bs-toggle="modal" data-bs-target="#gallery-image-modal" role="button" onClick={() => this.updatePopUp('12')}></div>
                                </div>
                                <div className="d-flex justify-content-center py-4">
                                    <Link className="no_border" onClick={() => this.goToTop()} to={match + "/gallery-innovations"}><button className="btn btn-highlight01 px-4 py-1"><strong>{t('btn-see-more')}</strong></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="gallery-image-modal" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <img className="modal-content" id="gallery-image-popup" src="" alt="" />
                        </div>
                    </div>

                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal3" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Gallery);



// WEBPACK FOOTER //
// ./src/components/pages/gallery.js